/**
 * Single invoice API host for create / config / drafts.
 *
 * Production builds used to invert NODE_ENV and call http://192.168.0.30:5000
 * (LAN-only). Localhost `npm run serve` hit https://ats.sattvahuman.in/api/
 * — so templates, column types, and formula prefs worked locally and failed
 * on the deployed app. Always use the public ATS invoice API.
 */
export const INVOICE_PROD_API_URL = 'https://ats.sattvahuman.in/api/'

function isPrivateLanHost(url) {
  return /192\.168\.|10\.\d+\.|172\.(1[6-9]|2\d|3[01])\./.test(String(url || ''))
}

export function resolveInvoiceApiUrl() {
  const fromEnv = String(process.env.VUE_APP_API || '').trim()
  if (fromEnv && !isPrivateLanHost(fromEnv)) {
    return fromEnv.endsWith('/') ? fromEnv : `${fromEnv}/`
  }
  return INVOICE_PROD_API_URL
}
